import { Component, Inject, inject, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

import { LabelType } from '@personalized-supplements/app/core/enums/label';

import { LangPipe } from '../../pipes/lang.pipe';

type TIconAction = 'success' | 'error';

export interface ISnackBarData {
  text: string;
  labelKey?: string;
  icon?: {
    name: string;
    color?: string;
    custom?: boolean;
    action?: TIconAction;
  };
  closeButton?: boolean;
}

@Component({
  standalone: true,
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
  imports: [MatIconModule, LangPipe],
  host: {
    class: 'mark-cdr-snack-bar',
  },
  encapsulation: ViewEncapsulation.None,
})
export class SnackBarComponent {
  snackBarRef = inject(MatSnackBarRef);

  readonly LabelType = LabelType;
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: ISnackBarData) {}
}
